import { EMPTY_LAYER, useAddPersonalLayer } from "hooks/layerHooks";

import { LayerFormValues } from "types/types";

import { LayerForm } from "./LayerForm";

interface Props {
  setIsDialogOpen: (isDialogOpen: boolean) => void;
}

export function AddLayer(props: Props) {
  const { setIsDialogOpen } = props;
  const { mutateAsync: add } = useAddPersonalLayer();
  const emptyLayer = EMPTY_LAYER;

  async function onSubmit(values: LayerFormValues) {
    add(values);
    setIsDialogOpen(false);
  }

  return (
    <LayerForm
      onSubmit={onSubmit}
      initialValues={emptyLayer}
      setIsDialogOpen={setIsDialogOpen}
    />
  );
}
